import React, { FC, useState } from 'react';
import { useHistory } from 'react-router-dom';

import AssetsBuyingForm from '../../../components/forms/assets-buying-form/assets-buying-form';
import BuyingOperationsHistoryContainer from '../../../containers/operations-history/buying-operations-history-container';
import AppPageMain from '../../../modules/app-page/app-page--main';
import PageHeader from '../../../modules/page-header';
import TableHeaderWrapper from '../../../modules/table-header-wrapper/table-header-wrapper';
import TableWrapper from '../../../modules/table-wrapper/table-wrapper';

const AssetsInfoPage: FC = () => {
  const history = useHistory();
  const [value, setValue] = useState<number>();
  const onRefresh = (val: number) => {
    setValue(val);
  };

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                { link: '/assets', title: 'Активы' },
                { link: '#', title: 'Денежные требования' },
              ]}
              iconType="assets"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <TableWrapper>
              <div className="assets">
                <div className="assets__header">
                  <TableHeaderWrapper
                    // isHint
                    // hintPage="SALE"
                    leftContent="Покупка цифровых финансовых активов"
                    onCloseClick={() => history.replace('/assets')}
                  />
                </div>
                <div className="assets__body">
                  <div className="row">
                    <div className="col-19 col-lg-27 col-xl-14">
                      <AssetsBuyingForm value={value} />
                    </div>
                    <div className="col-19 col-lg-27 col-xl-18">
                      <BuyingOperationsHistoryContainer onRefresh={onRefresh} />
                    </div>
                  </div>
                </div>
              </div>
            </TableWrapper>
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default AssetsInfoPage;
